module.exports = __webpack_public_path__ + "static/media/boxact.31c4560b.svg";